<template>
    <table-template ref="dealerApplyRecordTable" actionUrl="/dbtCard/findDealerApplyRecord.action" :queryParams="queryParams">
        <template slot="search">
            <el-select v-model="queryParams.status" @change="$refs['dealerApplyRecordTable'].search()" clearable  placeholder="请选择审核状态">
                <el-option label="待审核" :value="1"></el-option>
                <el-option label="审核通过" :value="2"></el-option>
                <el-option label="审核不通过" :value="3"></el-option>
            </el-select>
            <el-date-picker
                    clearable
                    style="margin-left: 10px;"
                    v-model="createTimeSearch"
                    @change="onCreateTimeChanged"
                    type="datetimerange"
                    range-separator="至"
                    start-placeholder="申请时间开始"
                    end-placeholder="申请时间截止">
            </el-date-picker>

            <el-input style="margin-left: 10px;width: 200px;" v-model="queryParams.keyword" placeholder="昵称/手机号/公司名称"></el-input>
            <el-button style="margin-left: 10px;" type="primary" @click="$refs['dealerApplyRecordTable'].search()" >搜索</el-button>

        </template>
        <template slot="item">
            <el-table-column
                    prop="nickname"
                    label="昵称">
            </el-table-column>
            <el-table-column
                    prop="phone"
                    label="手机号">
            </el-table-column>
            <el-table-column
                    prop="companyName"
                    label="公司名称">
            </el-table-column>
            <el-table-column
                    prop="cardCount"
                    label="推广业绩">
                <template scope="scope">
                    经纪人 {{scope.row.agentMember}} / 会员 {{scope.row.normalMember}}
                </template>
            </el-table-column>
            <el-table-column
                    label="状态">
                <template scope="scope">
                    <span v-bind:style="{color:getAuditStatusColor(scope.row.status)}">{{scope.row.status|statusFilter}}</span>
                </template>
            </el-table-column>
            <el-table-column
                    prop="name"
                    label="申请时间">
                <template scope="scope">
                    {{scope.row.applyTime | dateTimeFormat}}
                </template>
            </el-table-column>
            <el-table-column
                    label="操作">
                <template scope="scope">
                    <el-button type="text" v-if="scope.row.status==1" v-confirm confirm-text="确定审核通过？" requestUrl="dbtCard/changeDealerApplyRecordStatus.action" :confirm-data="{id:scope.row.id,status:2}" @onConfirm="$refs['dealerApplyRecordTable'].loadList()">通过</el-button>
                    <el-button type="text" v-if="scope.row.status==1" v-confirm confirm-text="确定审核不通过？" requestUrl="dbtCard/changeDealerApplyRecordStatus.action" :confirm-data="{id:scope.row.id,status:3}" @onConfirm="$refs['dealerApplyRecordTable'].loadList()">不通过</el-button>
                </template>
            </el-table-column>
        </template>
    </table-template>
</template>
<script>
import TableTemplate from '@/components/TableTemplate'
export default {
  name: 'distributor-apply',
  data () {
    return {
      createTimeSearch: null,
      queryParams: {}
    }
  },
  components: { TableTemplate },
  filters: {
    statusFilter (value) {
      let filter_value = '暂无'
      switch (value) {
        case 1:// 待审核
          filter_value = '待审核'
          break
        case 2:// 审核通过
          filter_value = '审核通过'
          break
        case 3:// 审核不通过
          filter_value = '审核不通过'
          break
      }
      return filter_value
    }
  },
  methods: {
    onCreateTimeChanged (datetime) {
      if (!datetime || datetime[0] == null) {
        this.queryParams.createTimeSearchStart = null
        this.queryParams.createTimeSearchEnd = null
        this.$refs['dealerApplyRecordTable'].search()
        return
      }
      this.queryParams.createTimeSearchStart = datetime[0].getTime()
      this.queryParams.createTimeSearchEnd = datetime[1].getTime()
      this.$refs['dealerApplyRecordTable'].search()
    },
    getAuditStatusColor (status) {
      let color = ''
      switch (status) {
        case 2:// 2-审核通过
          color = '#00CC00'
          break
        case 3:// 3-审核不通过;
          color = '#FF0000'
          break
        default:// 1-待审核;
          color = '#909399'
      }
      return color
    }
  }
}
</script>
